import BackButton from './BackButton.vue'

export default function () {
  return { component: BackButton }
}
